// extracted by mini-css-extract-plugin
module.exports = {"root":"LoadMoreObserver_root__q3yxv","rootCenter":"LoadMoreObserver_rootCenter__3aj93","noPaddingBottom":"LoadMoreObserver_noPaddingBottom__2yFLH"};